/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable object-curly-spacing */
/* eslint-disable no-unused-vars */
/* eslint-disable operator-linebreak */
/* eslint-disable jsx-quotes */
/* eslint-disable import/order */
import './summaryForm.css';

import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';

import CategoryAndSubcategoryJSON from '../../CategoryAndSubcategory.json';
import ConfirmationModal from '../Modals/confirmationModal';
import InfoIcon from '@mui/icons-material/Info';
import { LoadingButton } from '@mui/lab';
import { ModalClose } from '@mui/joy';
import PriorityConstants from '../../constants/priorityConstants';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';

export const formatText = (input) => {
  // Split the input into sections
  const sections = input.split(';').map((section) => section.trim());

  // Process each section
  const formattedSections = sections
    .filter((section) => section !== '')
    .map((section) => {
      // Split section header from content
      const [header, content] = section.split(':').map((part) => part.trim());

      // For "Potential Root Causes", split by numbers and spaces
      if (header === 'Potential Root Causes') {
        const items = content.split(/\d+\./).filter((item) => item.trim());
        const formattedItems = items.map(
          (item, index) => `${index + 1}. ${item.trim()}`
        );
        return `${header}: \n${formattedItems.join('\n')}`;
      }

      // EHS risks are split by "Space Pipe Space" (" | ")
      if (header === 'EHS Risks') {
        const items = content.split(' | ').map((item) => item.trim());
        const formattedItems = items.map(
          (item, index) => `${index + 1}. ${item}`
        );
        return `${header}: \n${formattedItems.join('\n')}`;
      }

      return section;
    });

  return formattedSections.join('\n\n');
};

function SummaryForm({
  isSummaryFormVisible,
  placeWO,
  onClose,
  loading,
  duplicateWorkorderId = '',
  woType = '',
  woDetail,
}) {
  const [isConfirmationModalVisible, setIsConfirmationModalVisible] =
    useState(false);
  const [bottomText, setBottomText] =
    useState(`Marking WO #${duplicateWorkorderId} as a Duplicate of this
                      current WO`);
  const maxBriefDescription = 35;
  const maxProblemDescription = 1500;
  const maxTechnicianNotes = 1500;
  const maxAccessNotesLength = 1500;

  const formik = useFormik({
    initialValues: {
      pteGranted: woDetail?.isVacant ? 'yes' : (woDetail?.pteGranted || 'no'),
      petsOrChildrenPresent: woDetail?.isVacant ? 'no' : (woDetail?.petsOrChildrenPresent || 'no'),
      categorization: woDetail?.categorization || '',
      subCategory: woDetail?.subCategory || '',
      prioritization: woDetail?.prioritization || '',
      technicianNotes: woDetail?.technicianNotes || '',
      problemDescription: woDetail?.problemDescription || '',
      briefDescription: woDetail?.briefDescription?.replace(/[',/{}*<>:;]/g, '')?.trim() || '',
      requestorPhoneNumber: woDetail?.requestorPhoneNumber || '',
      requestorEmail: woDetail?.requestorEmail || '',
      alternativePhoneNumber: woDetail?.alternativePhoneNumber || '',
      alternativePhoneNumberForText:
        woDetail?.alternativePhoneNumberForText || '',
      alternativeEmail: woDetail?.alternativeEmail || '',
      status: woDetail?.status || '',
      isVacant: woDetail?.isVacant || false,
      accessNotes: woDetail?.accessNotes || '',
      address: woDetail?.address || '',
      unitCode: woDetail?.unitCode || '',
      propertyCode: woDetail?.propertyCode || '',
      leaseholder: woDetail?.requestorName || '',
    },
    enableReinitialize: false,
    validate: (formData) => {
      const errors = {};
      if (
        !formData.categorization ||
        !formData.subCategory ||
        !formData.prioritization ||
        !formData.pteGranted ||
        !formData.petsOrChildrenPresent
      ) {
        errors.name = 'Required';
      }
      if (!formData.briefDescription) {
        errors.briefDescription = `Brief description is required`;
      }
      if (formData.briefDescription.length > maxBriefDescription) {
        errors.briefDescription = `Must be ${maxBriefDescription} characters or less`;
      }
      if (!formData.problemDescription) {
        errors.problemDescription = `Problem description is required`;
      }
      if (formData.technicianNotes.length > maxTechnicianNotes) {
        errors.technicianNotes = `Must be ${maxTechnicianNotes} characters or less`;
      }
      if (formData.problemDescription.length > maxProblemDescription) {
        errors.problemDescription = `Must be ${maxProblemDescription} characters or less`;
      }
      return errors;
    },
    onSubmit: (formData) => {
      const woRequestBody = {
        ...formData,
        tenantCode: woDetail?.tenantCode,
        tenantId: woDetail?.tenantId,
        requestorName: woDetail?.requestorName,
        isEHS: woDetail?.isEHS,
        isMold: woDetail?.isMold,
        isBioHazard: woDetail?.isBioHazard,
      };
      placeWO(woRequestBody);
    },
  });

  const handleSanitizedSubmit = () => {
    formik.setFieldValue(
      'technicianNotes',
      formik.values.technicianNotes.replace(/[',/{}*<>:;]/g, '').trim()
    );
    formik.setFieldValue(
      'problemDescription',
      formik.values.problemDescription.replace(/[',/{}*<>:;]/g, '').trim()
    );
    formik.setFieldValue(
      'accessNotes',
      formik.values.accessNotes.replace(/[',/{}*<>:;]/g, '').trim()
    );

    console.log('brief description :: ', formik.values.briefDescription, ', length :: ', formik.values.briefDescription.length);
    const modifiedBriefDescription = formik.values.briefDescription
      .replace(/[',/{}*<>:;]/g, '')
      .trim();
    console.log('modeified description :: ', modifiedBriefDescription, ', length :: ', modifiedBriefDescription.length);
    formik.setFieldValue('briefDescription', modifiedBriefDescription);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.values.prioritization === PriorityConstants.Emergency) {
      formik.setFieldValue('pteGranted', 'yes');
    }
    if (formik.values.technicianNotes) {
      const formattedTechnicianNotes = formatText(
        formik.values.technicianNotes
      );

      formik.setFieldValue('technicianNotes', formattedTechnicianNotes);

      // const hasNewLine = formik.values.technicianNotes.includes('\n');
      // const isNumberedListFormat = (text) => {
      //   const [label, options] = text.split(':');
      //   return options && options.trim().match(/^\d+\./);
      // };
      // if (isNumberedListFormat(formik.values.technicianNotes) && !hasNewLine) {
      //   const [label, options] = formik.values.technicianNotes.split(':');
      //   const formattedOptions = options.trim().split(/(?=\d+\.)/)
      //     .filter((option) => option.trim())
      //     .map((option) => option.trim())
      //     .join('\n');
      //   const formattedTechnicianNotes = `${label.trim()}:\n${formattedOptions}`;
      //   formik.setFieldValue('technicianNotes', formattedTechnicianNotes);
      // } else {
      //   formik.setFieldValue('technicianNotes', formik.values.technicianNotes.trim());
      // }
    }
    if (formik.values.problemDescription) {
      const hasNewLine = formik.values.problemDescription.includes('\n');
      const startsWithNumberedList =
        formik.values.problemDescription.startsWith('1.');

      const isQuestionAnswerFormat = (text) => {
        const pairs = text.split(',');
        return pairs.every(
          (pair) => pair.includes(':') && pair.split(':').length === 2
        );
      };

      if (startsWithNumberedList) {
        if (hasNewLine) {
          formik.setFieldValue(
            'problemDescription',
            formik.values.problemDescription.trim()
          );
        } else if (isQuestionAnswerFormat(formik.values.problemDescription)) {
          const pairs = formik.values.problemDescription
            .split(',')
            .filter((pair) => pair.trim());

          if (pairs && pairs.length) {
            const formattedProblemDescription = pairs
              .map((pair, index) => {
                const [question, answer] = pair.split(':');
                if (question && answer) {
                  return `${index + 1}. ${question.trim()} ${answer.trim()}`;
                }
                return '';
              })
              .filter((line) => line.trim())
              .join('\n');
            formik.setFieldValue(
              'problemDescription',
              formattedProblemDescription
            );
          } else {
            formik.setFieldValue(
              'problemDescription',
              formik.values.problemDescription.trim()
            );
          }
        }
      } else if (isQuestionAnswerFormat(formik.values.problemDescription)) {
        const pairs = formik.values.problemDescription
          .split(',')
          .filter((pair) => pair.trim());

        if (pairs && pairs.length) {
          const formattedProblemDescription = pairs
            .map((pair, index) => {
              const [question, answer] = pair.split(':');
              if (question && answer) {
                return `${index + 1}. ${question.trim()} ${answer.trim()}`;
              }
              return '';
            })
            .filter((line) => line.trim())
            .join('\n');
          formik.setFieldValue(
            'problemDescription',
            formattedProblemDescription
          );
        } else {
          formik.setFieldValue(
            'problemDescription',
            formik.values.problemDescription.trim()
          );
        }
      } else {
        formik.setFieldValue(
          'problemDescription',
          formik.values.problemDescription.trim()
        );
      }
    }
    if (formik.values.accessNotes) {
      const hasNewLine = formik.values.accessNotes.includes('\n');
      const isSemicolonSeparated = formik.values.accessNotes.includes(';');

      const isQuestionAnswerFormat = (text) => {
        const parts = text.split(';');
        return parts.every(
          (part) => part.includes(':') && part.split(':').length === 2
        );
      };

      if (
        isSemicolonSeparated &&
        isQuestionAnswerFormat(formik.values.accessNotes)
      ) {
        const parts = formik.values.accessNotes
          .split(';')
          .filter((part) => part.trim());

        if (parts && parts.length) {
          const formattedAccessNotes = parts
            .map((part) => part.trim())
            .join('\n');
          formik.setFieldValue('accessNotes', formattedAccessNotes);
        } else {
          formik.setFieldValue('accessNotes', formik.values.accessNotes.trim());
        }
      } else if (hasNewLine) {
        formik.setFieldValue('accessNotes', formik.values.accessNotes.trim());
      } else {
        formik.setFieldValue('accessNotes', formik.values.accessNotes.trim());
      }
    }
    if (woType === 'Repeat') {
      setBottomText(`Marking WO #${duplicateWorkorderId} as a Repeat of this
                      current WO`);
    } else if (woType === 'Reopen') {
      setBottomText(`Marking WO #${duplicateWorkorderId} as a Re-open of this
                      current WO`);
    }
  }, [formik.values.prioritization]);

  const isTechnicianNotesDisabled = () => {
    if (duplicateWorkorderId || woType === 'Reopen') {
      return true;
    }
    if (woType === 'Repeat') {
      return loading;
    }
    return false;
  };

  return (
    <>
      <Modal
        open={isSummaryFormVisible}
        aria-labelledby='parent-modal-title'
        aria-describedby='parent-modal-description'
        key='summary'
      >
        <div className='submit-popup-container'>
          <form className='form-element'>
            <Box
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: '60%',
                height: '90%',
                bgcolor: 'background.paper',
                boxShadow: 24,
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 2,

                minWidth: '500px',
                overflow: 'scroll',
              }}
            >
              <ModalClose
                onClick={() => {
                  if (!loading) {
                    formik.resetForm();
                    onClose();
                  }
                }}
                color='#434343'
              />
              <Box
                sx={{
                  overflow: 'auto',
                  flexGrow: 1,
                  p: 4,
                  flexDirection: 'column',
                  display: 'flex',
                }}
              >
                <Box
                  display='flex'
                  justifyContent='flex-start'
                  marginBottom={2}
                >
                  <Typography
                    id='modal-modal-title'
                    color='#52663c'
                    fontSize={24}
                  >
                    WO Summary
                  </Typography>
                </Box>
                <Box display='flex'>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Autocomplete
                        fullWidth
                        autoComplete
                        autoFocus
                        autoHighlight
                        options={Object.keys(CategoryAndSubcategoryJSON)}
                        id='category'
                        value={formik.values.categorization}
                        readOnly
                        disabled
                        renderInput={(params) => (
                          <TextField
                            onChange={formik.handleChange}
                            color='success'
                            required
                            fullWidth
                            {...params}
                            label='Category'
                            variant='standard'
                            autoFocus
                            name='categorization'
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Autocomplete
                        fullWidth
                        options={
                          CategoryAndSubcategoryJSON[
                            formik.values.categorization
                          ] || []
                        }
                        value={formik.values.subCategory}
                        id='sub-category'
                        readOnly
                        disabled
                        renderInput={(params) => (
                          <TextField
                            color='success'
                            required
                            fullWidth
                            {...params}
                            label='Sub Category'
                            variant='standard'
                            name='subCategory'
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        color='success'
                        id='priority'
                        fullWidth
                        select
                        name='prioritization'
                        variant='standard'
                        label='Priority'
                        value={formik.values.prioritization}
                        disabled
                        onChange={formik.handleChange}
                        inputProps={{
                          readOnly: true,
                        }}
                      >
                        {Object.keys(PriorityConstants).map((priority) => (
                          <MenuItem
                            key={priority}
                            value={PriorityConstants[priority]}
                          >
                            {priority}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        color='success'
                        onChange={formik.handleChange}
                        id='brief-description'
                        name='briefDescription'
                        label='Brief Description'
                        variant='standard'
                        value={formik.values.briefDescription}
                        disabled={loading}
                        required
                        inputProps={{
                          maxLength: maxBriefDescription,
                        }}
                        helperText={
                          formik.errors.briefDescription
                            ? `${
                              formik.values.briefDescription?.length || 0
                            } / ${maxBriefDescription} ${
                              formik.errors.briefDescription
                            }`
                            : `${
                              formik.values.briefDescription?.length || 0
                            } / ${maxBriefDescription}`
                        }
                        FormHelperTextProps={{
                          sx: {
                            marginLeft: 0,
                            marginRight: 0,
                          },
                        }}
                        error={Boolean(formik.errors.briefDescription)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        color='success'
                        onChange={formik.handleChange}
                        onInputChange={formik.values.problemDescription}
                        value={formik.values.problemDescription}
                        id='problem-description'
                        name='problemDescription'
                        label='Problem Description'
                        variant='filled'
                        required
                        disabled={loading}
                        inputProps={{
                          maxLength: maxProblemDescription,
                        }}
                        FormHelperTextProps={{
                          sx: {
                            marginLeft: 0,
                            marginRight: 0,
                          },
                        }}
                        helperText={
                          formik.errors.problemDescription
                            ? `${
                              formik.values.problemDescription?.length || 0
                            } / ${maxProblemDescription} ${
                              formik.errors.problemDescription
                            }`
                            : `${
                              formik.values.problemDescription?.length || 0
                            } / ${maxProblemDescription}`
                        }
                        rows={4}
                        multiline
                        error={Boolean(formik.errors.problemDescription)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        fullWidth
                        onChange={formik.handleChange}
                        color='success'
                        value={formik.values.technicianNotes}
                        onInputChange={formik.values.technicianNotes}
                        id='technician-notes'
                        name='technicianNotes'
                        label='Technician Notes'
                        disabled={isTechnicianNotesDisabled()}
                        variant='filled'
                        inputProps={{
                          maxLength: maxTechnicianNotes,
                        }}
                        FormHelperTextProps={{
                          sx: {
                            marginLeft: 0,
                            marginRight: 0,
                          },
                        }}
                        helperText={
                          formik.errors.technicianNotes
                            ? `${
                              formik.values.technicianNotes?.length || 0
                            } / ${maxTechnicianNotes} ${
                              formik.errors.technicianNotes
                            }`
                            : `${
                              formik.values.technicianNotes?.length || 0
                            } / ${maxTechnicianNotes}`
                        }
                        rows={4}
                        multiline
                        error={Boolean(formik.errors.technicianNotes)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        required
                        fullWidth
                        onChange={formik.handleChange}
                        color='success'
                        value={formik.values.accessNotes}
                        onInputChange={formik.values.accessNotes}
                        id='access-notes'
                        name='accessNotes'
                        label='Access Notes'
                        variant='filled'
                        disabled={loading}
                        inputProps={{
                          maxLength: maxAccessNotesLength,
                        }}
                        FormHelperTextProps={{
                          sx: {
                            marginLeft: 0,
                            marginRight: 0,
                          },
                        }}
                        helperText={`${
                          formik.values.accessNotes?.length || 0
                        } / ${maxAccessNotesLength}`}
                        rows={4}
                        multiline
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id='address'
                        fullWidth
                        value={formik.values.address}
                        color='success'
                        variant='standard'
                        label='Address'
                        disabled
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id='neighborhood'
                        fullWidth
                        value={formik.values.propertyCode}
                        color='success'
                        variant='standard'
                        label='Neighborhood Code'
                        disabled
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id='lease-holder-name'
                        fullWidth
                        value={formik.values.leaseholder}
                        color='success'
                        variant='standard'
                        label='Lease Holder Name'
                        disabled
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id='yardi-unit-cde'
                        fullWidth
                        value={formik.values.unitCode}
                        color='success'
                        variant='standard'
                        disabled
                        inputProps={{
                          readOnly: true,
                        }}
                        label='Yardi Unit Code'
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id='phone'
                        fullWidth
                        value={formik.values.requestorPhoneNumber}
                        color='success'
                        variant='standard'
                        disabled
                        label='Phone'
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        id='email'
                        fullWidth
                        value={formik.values.requestorEmail}
                        variant='standard'
                        color='success'
                        disabled
                        label='Email'
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl id='pte-granted'>
                        <FormLabel color='success'>
                          Permission to enter?
                        </FormLabel>
                        <RadioGroup
                          name='pteGranted'
                          value={formik.values.pteGranted}
                          onChange={formik.handleChange}
                          color='success'
                        >
                          <FormControlLabel
                            control={
                              <Radio color='success' disabled={formik.values.isVacant || loading} />
                            }
                            label='Yes'
                            color='success'
                            value='yes'
                          />
                          <FormControlLabel
                            control={
                              <Radio
                                color='success'
                                disabled={
                                  formik.values.isVacant ||
                                  formik.values.prioritization ===
                                    PriorityConstants.Emergency || loading
                                }
                              />
                            }
                            label='No'
                            color='success'
                            value='no'
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                      <FormControl id='pets-or-children-present'>
                        <FormLabel color='success'>
                          Pets/ Children present?
                        </FormLabel>
                        <RadioGroup
                          name='petsOrChildrenPresent'
                          value={formik.values.petsOrChildrenPresent}
                          onChange={formik.handleChange}
                          color='success'
                        >
                          <FormControlLabel
                            value='yes'
                            control={
                              <Radio color='success' disabled={formik.values.isVacant || loading} />
                            }
                            label='Yes'
                            color='success'
                          />
                          <FormControlLabel
                            value='no'
                            control={
                              <Radio color='success' disabled={formik.values.isVacant || loading} />
                            }
                            label='No'
                            color='success'
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
              <Box
                display='flex'
                flexDirection='column'
                justifyContent='center'
                alignItems='center'
                p={2}
                sx={{ borderTop: '1px solid #e0e0e0' }}
                gap={1}
              >
                {duplicateWorkorderId && (
                  <Box alignSelf='flex-start' display='flex' gap={1}>
                    <InfoIcon color='success' sx={{ fontSize: 20 }} />
                    <Typography fontSize={14}>{bottomText}</Typography>
                  </Box>
                )}
                <LoadingButton
                  variant='contained'
                  type='button'
                  loading={loading}
                  onClick={() => {
                    formik.validateForm().then((valid) => {
                      if (Object.keys(valid).length === 0) {
                        setIsConfirmationModalVisible(true);
                      }
                    });
                  }}
                  color='success'
                  sx={{ borderRadius: 2, textTransform: 'none' }}
                >
                  <span>Submit WO to Yardi</span>
                </LoadingButton>
              </Box>
            </Box>
          </form>
        </div>
      </Modal>
      <ConfirmationModal
        open={isConfirmationModalVisible}
        onClose={() => setIsConfirmationModalVisible(false)}
        onSubmit={handleSanitizedSubmit}
      />
    </>
  );
}

SummaryForm.propTypes = {
  isSummaryFormVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  placeWO: PropTypes.func.isRequired,
  duplicateWorkorderId: PropTypes.string,
  woType: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  woDetail: PropTypes.shape({
    categorization: PropTypes.string,
    subCategory: PropTypes.string,
    prioritization: PropTypes.string,
    technicianNotes: PropTypes.string,
    problemDescription: PropTypes.string,
    briefDescription: PropTypes.string,
    requestorPhoneNumber: PropTypes.string,
    requestorEmail: PropTypes.string,
    pteGranted: PropTypes.string,
    petsOrChildrenPresent: PropTypes.string,
    address: PropTypes.string,
    unitCode: PropTypes.string,
    propertyCode: PropTypes.string,
    leaseholder: PropTypes.string,
    tenantCode: PropTypes.number,
    tenantId: PropTypes.string,
    requestorName: PropTypes.string,
    alternativePhoneNumber: PropTypes.string,
    alternativePhoneNumberForText: PropTypes.string,
    alternativeEmail: PropTypes.string,
    status: PropTypes.string,
    isVacant: PropTypes.bool,
    accessNotes: PropTypes.string,
    isMold: PropTypes.bool,
    isEHS: PropTypes.bool,
    isBioHazard: PropTypes.bool,
  }).isRequired,
};

SummaryForm.defaultProps = {
  duplicateWorkorderId: '',
  woType: '',
};

export default SummaryForm;
